module.exports = __webpack_public_path__ + "static/img/fun1.27f45f4f.png";